import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: string;
}

export function ProtectedRoute({ children, requiredRole }: ProtectedRouteProps) {
  const { user, roles, isLoading } = useAuth();

  // Show nothing while auth state is loading to prevent flash
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-dark">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) return <Navigate to="/auth" replace />;

  if (requiredRole && !roles.includes(requiredRole)) {
    // super_admin bypasses all role gates
    if (!roles.includes("super_admin")) {
      console.warn(`[ProtectedRoute] Access denied: user lacks role "${requiredRole}". Roles: ${roles.join(", ")}`);
      return <Navigate to="/" replace />;
    }
  }

  return <>{children}</>;
}
